



















































































import { Vue, Component, Prop } from "vue-property-decorator";
import * as activity from "../../_store/activity.module";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { router } from "../../_router";
import * as temp from "../../_store/temp.module";

@Component
export default class WorkshopSubscriptionDialog extends Vue {
  private dialog: boolean;
  private articolazioni: any;
  private idIstituto: number;
  private idAzienda: number;
  private idAttivita: number;
  private settoriSelected: any;
  private selection: any;
  private listaSelection: any;

  private lastname: string;
  private name: string;
  private email: string;

  private statoPeriodoIscrizione: boolean;
  private dataFineAttivita: string;

  private lastnameRules: [boolean | string];
  private nameRules: [boolean | string];
  private emailRules: [boolean | string];

  constructor() {
    super();
    this.dialog = false;
    this.articolazioni = [];
    this.idIstituto = 0;
    this.idAzienda = 0;
    this.idAttivita = 0;
    this.settoriSelected = [];
    this.selection = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "più di 10"];
    this.lastname = "";
    this.name = "";
    this.email = "";
    this.listaSelection = [];

    this.lastnameRules = [true];
    this.nameRules = [true];
    this.emailRules = [true];

    this.statoPeriodoIscrizione = false;
    this.dataFineAttivita = "";
  }

  validazioneCognome() {
    var valid: boolean = false;
    if (this.lastname !== "" || this.lastname !== null) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.lastname);
    }
    if (valid) {
      this.lastnameRules = [true];
    } else if (this.lastname === "") {
      this.lastnameRules = ["Cognome Referente necessario"];
    } else {
      this.lastnameRules = [
        "Cognome Referente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneNome() {
    var valid: boolean = false;
    if (this.name !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.name);
    }
    if (valid) {
      this.nameRules = [true];
    } else if (this.name === "") {
      this.nameRules = ["Nome Referente necessario"];
    } else {
      this.nameRules = [
        "Nome Referente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }

  validazioneEmail() {
    var valid: boolean = false;
    if (this.email !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(this.email);
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.email === "") {
      this.emailRules = ["Email Referente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }

  aggiungiRisposta(value: any, idDomanda: string) {
    let alreadyExist: boolean = false;
    let indiceRisposta: any;
    let valoreRisposta: string = "";
    // if (typeof value === "string") {
    valoreRisposta = value;
    // }
    alreadyExist = this.listaSelection.some(
      (risposta: any) => risposta["idDomanda"] === idDomanda
    );
    if (alreadyExist) {
      indiceRisposta = this.listaSelection.findIndex(
        (risposta: any) => risposta.idDomanda === idDomanda
      );
      this.listaSelection[indiceRisposta].risposta = valoreRisposta;
    } else {
      this.listaSelection.push({
        idDomanda: idDomanda,
        risposta: valoreRisposta
      });
    }
  }

  loadArticolazioni() {
    var articolazione = {
      idArticolazione: "",
      nomArticolazione: ""
    };
    var articolazioni: any[] = [];
    data
      .dispatchArticolazioni(this["$store"], this.idIstituto)
      .then(response => {
        response.forEach(function(element: any) {
          articolazione = {
            idArticolazione: element.idArticolazione,
            nomArticolazione: element.nomeArticolazione
          };
          articolazioni.push(articolazione);
        });
        this.articolazioni = articolazioni;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  checkSettori() {
    if (this.settoriSelected.length > 0) {
      if (this.settoriSelected.length === this.listaSelection.length) {
        this.save();
      } else {
        bus.$emit(
          "errorOperation",
          "Per uno o più settori non sono state specificate le risorse da inserire"
        );
      }
    } else {
      bus.$emit("errorOperation", "Selezionare almeno un settore di interesse");
    }
  }

  async executeTest() {
    this.validazioneCognome();
    this.validazioneNome();
    this.validazioneEmail();
  }

  save() {
    var payload = {
      idAttivita: this.idAttivita,
      idAzienda: this.idAzienda
    };
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        activity
          .dispatchSubscribeToActivityAzienda(this["$store"], payload)
          .then((idIscrizione: number) => {
            this.listaSelection.forEach((selezione: any) => {
              var payload2 = {
                idAzienda: this.idAzienda,
                idIscrizione: idIscrizione,
                scelta: {
                  scelta: selezione.risposta,
                  idArticolazione: selezione.idDomanda
                },
                referente: {
                  lastname: this.lastname,
                  name: this.name,
                  email: this.email
                }
              };
              activity
                .dispatchAddWorkshopPreference(this["$store"], payload2)
                .then(() => {
                  bus.$emit(
                    "successfullOperation",
                    "Iscrizione al workshop avvenuta con successo"
                  );
                  this.dialog = false;
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", error.response.statusText);
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", error.response.statusText);
                  }
                });
            });
            router.push({
              name: "workshopAzienda",
              params: {
                idIstituto: String(this.idIstituto),
                idAnnoScolastico: String(idAnnoScolastico),
                idIscrizioneAttivita: String(idIscrizione),
                statoPeriodoIscrizione: String(this.statoPeriodoIscrizione),
                dataFineAttivita: String(this.dataFineAttivita)
              }
            });
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }

  close() {
    this.dialog = false;
    this.articolazioni = [];
    this.idIstituto = 0;
    this.settoriSelected = [];
    this.selection = ["1", "2", "più di 2", "tra 5 e 10", "più di 10"];
    this.lastname = "";
    this.name = "";
    this.email = "";
    this.listaSelection = [];

    this.lastnameRules = [true];
    this.nameRules = [true];
    this.emailRules = [true];
  }

  created() {
    bus.$on("openWorkshopSubscription", (data: any) => {
      this.dialog = true;
      this.idIstituto = data.idIstituto;
      this.idAttivita = data.idAttivita;
      this.idAzienda = data.idAzienda;
      this.statoPeriodoIscrizione = data.statoPeriodoIscrizione;
      this.dataFineAttivita = data.dataFineAttivita;
      this.loadArticolazioni();
    });
  }
}
